"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZIndexFromLayer = void 0;

var _constants = require("./constants");

// The z-index is dictated by the position of a layer in the OrderedLayers array
// We increment it by 1 so the first z-index used is 1 and not 0
var getZIndexFromLayer = function getZIndexFromLayer(layer) {
  var index = _constants.OrderedLayers.indexOf(layer);

  if (index >= 0) {
    return index + 1;
  }

  return 0;
};

exports.getZIndexFromLayer = getZIndexFromLayer;